import { render, staticRenderFns } from "./UserAccessDetails.vue?vue&type=template&id=f7e683c8&lang=pug"
import script from "./UserAccessDetails.vue?vue&type=script&lang=js"
export * from "./UserAccessDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7e683c8')) {
      api.createRecord('f7e683c8', component.options)
    } else {
      api.reload('f7e683c8', component.options)
    }
    module.hot.accept("./UserAccessDetails.vue?vue&type=template&id=f7e683c8&lang=pug", function () {
      api.rerender('f7e683c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tableau/UserAccessDetails.vue"
export default component.exports